// ShortcutService.js
import { BaseService } from './BaseService';

export class ShortcutService extends BaseService {
  constructor() {
    super('/api');
  }

  detectPlatform() {
    try {
      const isMac = navigator.platform && navigator.platform.toLowerCase().includes('mac');
      return isMac ? 'mac' : 'windows';
    } catch (_e) {
      return 'windows';
    }
  }

  async fetchAll() {
    const res = await this.get('/shortcuts');
    if (res && res.success && res.data) return res.data;
    return { mac: {}, windows: {} };
  }

  async getPlatformShortcuts() {
    const all = await this.fetchAll();
    const platform = this.detectPlatform();
    return platform === 'mac' ? (all.mac || {}) : (all.windows || {});
  }

  async replacePlatformShortcuts(platform, shortcutsMap) {
    const res = await this.put(`/shortcuts/${platform}`, shortcutsMap);
    if (res && res.success && res.data) return res.data;
    throw new Error('Failed to update shortcuts');
  }
}


